import { createSlice } from '@reduxjs/toolkit';

//**********************************************************

// define a type for the slice state
interface tracking
{
    isPlay: boolean;
}

//**********************************************************

export const trackingState = createSlice
(
    {
        name: 'trackingState',
        initialState:
            {
                isPlay: false,
            },
        reducers:
            {
                save: (state, action) =>
                {
                    state.isPlay = action.payload.isPlay;

                    console.log(action.payload.isPlay);
                },
            },
    }
);

// Action creators are generated for each case reducer function
export const { save } = trackingState.actions;

export default trackingState.reducer;
